import * as React from 'react';
import styles from './InsuranceProgressBar.css';
var InsuranceProgressBar = function (props) { return (React.createElement("div", { className: styles.insuranceProgressBar },
    React.createElement("div", { className: styles.insuranceProgressBar__fill, style: { width: "".concat(props.fillPercentage, "%") } }))); };
export default InsuranceProgressBar;
